import script from "./dropdown2.vue?vue&type=script&setup=true&lang=js"
export * from "./dropdown2.vue?vue&type=script&setup=true&lang=js"

import "./dropdown2.vue?vue&type=style&index=0&id=77015a92&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77015a92"]])

export default __exports__